import { useSelector } from 'react-redux';
import startCase from 'lodash/startCase';
import { getBenchmarkRange } from 'common/services/benchmarks.service';
import { activeGithubCloudIntegrationsSelector } from 'state/selectors/sensors-authorizations';
import useMetricsCalculationConfig from 'views/root/views/home/hooks/useMetricsCalculationConfig';
import useBenchmarkOrgSizeConfig from 'views/root/views/home/hooks/useBenchmarkOrgSizeConfig';
import { shouldShowGitStreamCTA } from '../../../custom-report.serivce';
import useSettingsService from 'components/hooks/useSettingsService';
import GitStreamCTABadgeWithTooltip from 'components/GitStreamCTABadgeWithTooltip';
import MetricsBenchmarkIcon from 'components/MetricsBenchmarkIcon';
import { isMulti } from 'common/utils/utils';

const getGitStreamBadgeContent = title => `Improve ${startCase(title)}`;

const Benchmark = ({
  metricName,
  average,
  title,
  graph,
  toggleModal,
  selectedContributor,
  globallySelectedTeams,
  globallySelectedTeamId,
  selectedTeam,
  selectedTeamId,
  granularity,
  calculationStrategy
}) => {
  const { getSettingOrDefinitionValue } = useSettingsService();
  const { metricsCalculationStrategy } = useMetricsCalculationConfig();
  const { benchmarkOrgSize } = useBenchmarkOrgSizeConfig();

  const githubCloudIntegrations = useSelector(
    activeGithubCloudIntegrationsSelector
  );
  const hideBenchmarkIconSettingsLink =
    isMulti(globallySelectedTeams) ||
    globallySelectedTeamId !== selectedTeam?.id;
  const shouldShowBenchmarkIcon = !selectedContributor; // hide benchmarkIcon for individuals Metrics

  if (!shouldShowBenchmarkIcon) {
    return null;
  }
  const benchmarkRange = getBenchmarkRange({
    metricName,
    value: average,
    metricsCalculationStrategy:
      calculationStrategy ?? metricsCalculationStrategy,
    benchmarkOrgSize
  });

  const showGitStreamCTA =
    githubCloudIntegrations.length > 0 &&
    shouldShowGitStreamCTA(
      average,
      benchmarkRange,
      graph,
      getSettingOrDefinitionValue,
      selectedTeamId
    );

  return (
    <>
      {showGitStreamCTA && (
        <GitStreamCTABadgeWithTooltip
          title={title}
          gitStreamBadgeContent={getGitStreamBadgeContent(title)}
          position='bottom'
        />
      )}
      <MetricsBenchmarkIcon
        metricName={metricName}
        value={average}
        margin='0.4rem 0.4rem 0rem 0rem'
        toggleModal={toggleModal}
        selectedTeamId={selectedTeamId}
        granularity={granularity}
        hideSettingsLink={hideBenchmarkIconSettingsLink}
        calculationStrategy={calculationStrategy}
      />
    </>
  );
};

export default Benchmark;
